<template>
  <div>
    <!-- User Summary Section Start -->
    <div></div>
    <b-button v-if="userID > 0" class="mb-1 mt-1" @click="showUserModal(userID)" size="xs"
      style="font-size: 0.575rem">User Summary</b-button>
    <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="User-modal" hide-footer :title="Page_title">
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <b-row>
        <b-col md="4">
          <label>Date</label>
          <date-range-picker :opens="openLeft" :always-show-calendars="showCal" v-model="dateRange"
            :startDate="startDate" :endDate="endDate" :locale-data="locale"  @input="getAssignmentPendencyList" />
        </b-col>
        <b-col md="4">
          <label>Client</label>
          <model-list-select :list="$store.getters['common/getAllClientList']" id="clientIdFilter"
            v-model="clientIdFilter" option-value="clientId" option-text="clientName"
            placeholder="Select  Client Name" @input="getAssignmentPendencyList" />
        </b-col>
        <b-col md="4">
          <label>Sline</label>
          <model-list-select :list="$store.getters['common/getAllShippingLineList']" id="shippingFilter"
            v-model="shippingFilter" option-value="shippingId" option-text="shippingLine"
            placeholder="Select Shipping Line" @input="getAssignmentPendencyList" />
        </b-col>
        <b-col md="4">
          <b-button class="mt-2 ml-3"
            :disabled="ExcelBtnName4 != 'Export Assignments' ? true : false"
            @click="getSalesAss('All_Sales_Excel', 'Export Assignments')" size="sm" variant="outline-info">
            {{ ExcelBtnName4 }}
            <b-spinner v-if="ExcelBtnName4 != 'Export Assignments'" small label="Small Spinner"></b-spinner></b-button>
        </b-col>
        <b-col md="12" style="color: black;">
          <b>Transport Prefrence: {{ PMC_TransportTypePre }}</b>
        </b-col>
        <b-col md="12"  style="color: black;">
          <b>Branch/CLient Prefrence : {{ PMC_BranchClientPre == '1' ? 'Branch' : 'Client' }}</b>
        </b-col>
        <b-col md="12" style="color: black;">
          <b>Branch Details</b>
        </b-col>
        <b-col md="4" v-for="(item, index1) in BranchList" :key="index1"  style="color: black;">
          {{ parseInt(index1 + 1) + ". " + item.mainLocation }}
        </b-col>
        <b-col md="12" style="color: black;">
          <b>Client Details</b>
        </b-col>
        <b-col md="4" v-for="(item, index) in ClientList" :key="index"  style="color: black;">
          {{ parseInt(index + 1) + ". " + item.clientName }}
        </b-col>
        <b-col cols="12" class="text-center">
          <b-button class="mt-3" variant="outline-danger" size="xs" style="font-size: 0.675rem"
            @click="hideUserModal">Close</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>

  <!-- User Summary Section End -->
</template>

<script>
import DatePicker from "vue2-datepicker";
import DateRangePicker from "vue2-daterange-picker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import CommonService from "../../services/CommonService.js";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";

export default {
  props: {
    PMC_title: {
      type: String,
      default: "",
    },
    PMC_USERID: {
      type: String,
      default: "",
    },
    PMC_USERNAME: {
      type: String,
      default: "",
    },
    PMC_USERDESIG: {
      type: String,
      default: "",
    },
    PMC_BranchClientPre: {
      type: String,
      default: "",
    },
    PMC_TransportTypePre: {
      type: String,
      default: "",
    },
    PMC_UserEmpName: {
      type: String,
      default: "",
    },
    PMC_UserEmpCode: {
      type: String,
      default: "",
    },
  },
  beforeMount() {
    if (this.PMC_USERID) {
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({
          itemCode: "ClientList",
        })
      );
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({
          itemCode: "ShippingLineList",
        })
      );
      // this.getUser();
    }
  },
  mounted() { },

  data() {
    return {
      generateExcel: 0,
      Page_title: this.PMC_title,
      totalRows: 0,
      currentPage: 1,
      perPage: 300,
      pageOptions: [100, 200, 300],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      UserList: [],
      ClientList: [],
      BranchList: [],
      userID: this.PMC_USERID,
      isLoading: false,
      ExcelBtnName: "Export As Excel",
      ExcelBtnName4: "Export Assignments",
      clientIdFilter: "",
      shippingFilter: "",
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      openLeft: "right",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      totalData: 0,
      docURL: URL_BASE_DOC,
      JOBList: [],
    };
  },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    DateRangePicker,
    ModelListSelect,
  },

  computed: {},
  watch: {},
  methods: {
    getSalesAss(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName4 = "Downloading Please Wait .....";
      this.getAssignmentPendencyList("Excell", "0", "0", "1", "1");
    },
    getAssignmentPendencyList(type) {

      let payload = {
        itemCode: "getBookingResp",
        type: type,
        page: 1,
        pageSize: 50,
        clientId: this.clientIdFilter,
        shippingFilter: this.shippingFilter,
        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        generateExcel: this.generateExcel,
        filter: {},
        isUserSummary: 1,
      };
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getAllSalesJobList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          // console.log("data PS=>", data.data);

          if (status == 200 && data) {
            if (this.generateExcel == "1") {

              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-Job-Sales-panel-report.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName4 = "Export Assignments";
              this.generateExcel = "0";
            } else {
              if (data.data.length > 0) {
                this.totalData = data.pagination.total;
                this.JOBList = data.data;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getBookingResp Error: ", error);
        });
    },
    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getUser("Excell");
    },
    getUser(type) {
      this.UserList = [];
      this.ClientList = [];
      this.BranchList = [];
      let payload = {};
      if (this.PMC_USERID) {
        if (type == "Normal") {
          this.isLoading = true;
        }
        payload = {
          itemCode: "getUserDetails",
          userID: this.PMC_USERID,
          UserEmpName: this.PMC_UserEmpName,
          UserEmpCode: this.PMC_UserEmpCode,
          type: type,
        };

        CommonService.getAllUserDetails(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log();
            if (status == 200 && data.UserListFLAG == 1) {
              this.isLoading = false;
              if (type == "Excell") {
                if (data.UserList.length > 0) {
                  this.UserList = data.UserList;
                }
                if (data.ClientList.length > 0) {
                  this.ClientList = data.ClientList;
                }
                if (data.BranchList.length > 0) {
                  this.BranchList = data.BranchList;
                }
                this.ExcelBtnName = "Export As Excel";
                window.location.href =
                  `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
              } else {
                if (data.UserList.length > 0) {
                  this.UserList = data.UserList;
                }
                if (data.ClientList.length > 0) {
                  this.ClientList = data.ClientList;
                }
                if (data.BranchList.length > 0) {
                  this.BranchList = data.BranchList;
                }
              }
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on UserList Error: ", error);
          });
      }
    },

    showUserModal(userID) {
      this.UserList = [];
      this.ClientList = [];
      this.BranchList = [];
      this.$refs["User-modal"].show();
      this.getUser("Normal");
      // this.isLoading = false;
    },
    hideUserModal() {
      this.UserList = [];
      this.ClientList = [];
      this.BranchList = [];
      this.$refs["User-modal"].hide();
      // this.isLoading = false;
    },
  },
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// userBasedClient.vue?77c41822